<template>
  <div class="slider-pill-borders">
    <div class="slider-wrapper primary-font gap-m">
      <div ref="left-slider"
        id="left-slider"
        class="flex absolute left-slider label-md-300 label-slider no-highlights"
        @click="updateChange(min)"
        role="button"
        @keydown.right="updateChange(max)"
        @keydown.left="updateChange(min)"
      >
        <span
          style="white-space: pre-wrap;"
          class="fluid-transition paragraph"
          :class="[
          slider < 20 ?  'orange-font-color'
            : slider > 80 && step == 3? 'primary-font-color'
          :'secondary-font-color'
          ]"
          type="buttton"
          tabindex="0"
          @keydown.enter="updateChange(min)"
          @keydown.space="updateChange(min)"
        >
          <slot name="left">
            LEFT
          </slot>
        </span>
      </div>
      <div
        ref="right-slider"
        id="right-slider"
        class="flex absolute right-slider label-md-300 label-slider no-highlights"
        @click="updateChange(max)"
        role="button"
      >
        <span
          style="white-space: pre-wrap;"
          class="fluid-transition paragraph"
          :class="[
            slider > 80 ?
              step == 1? 'orange-font-color'
              : 'secondary-font-color'
            : 'secondary-font-color'
          ]"
          type="buttton"
          tabindex="0"
          @keydown.enter="updateChange(max)"
          @keydown.space="updateChange(max)"
          @keydown.left="updateChange(min)"
          @keydown.right="updateChange(max)"
        >
          <slot name="right">
            right
          </slot>
        </span>
      </div>
      <div class="flex slider">
        <Slider
          ref="sliderTarget"
          :ballDiameter="sliderHeight"
          :selection="slider"
          @update:selection="updateSelection"
          @update:change="updateChange"
          :min
          :max
          :fontColor
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, nextTick, ref } from 'vue'
import { Slider } from '../../atoms'
import { type TypeFontColor, FontColor } from '../../interfaces';
const emit = defineEmits(['update:slider', 'update:change'])
const slider = defineModel('slider', {
  default: 49,
  type: Number
})

const leftSlider = ref<HTMLElement | null>(null)
const rightSlider = ref<HTMLElement | null>(null)
const sliderHeight = ref<number>(0)
const txtOnMultiplesLines = ref(false)
const extraBallSize = 14

export interface PropsSliderGroup {
  min?: number,
  max?: number,
  step?: number,
  fontColor?: TypeFontColor
}
const props = withDefaults(defineProps<PropsSliderGroup>(), {
  min: 0,
  max: 100,
  step: 1,
  fontColor: FontColor.secondary
})
const updateSelection = (value: number) => {
  if (!Number.isNaN(value)) slider.value = value
}
const updateChange = (value: number) => {
  if (!Number.isNaN(value)) emit('update:change', value)
}
//
const getParagraphHeight = () => {
  const leftSliderElement = leftSlider.value || document.getElementById('left-slider')
  const rightSliderElement = rightSlider.value || document.getElementById('right-slider')

  if (leftSliderElement && rightSliderElement) {
    const leftSize = leftSliderElement.getBoundingClientRect().height
    const rightSize = rightSliderElement.getBoundingClientRect().height
    sliderHeight.value = leftSize > rightSize ? leftSize + extraBallSize : rightSize + extraBallSize
    checkIfMultiLine()
  }
}

onMounted(() => {
  nextTick(() => {
    getParagraphHeight()
  })
})

const checkIfMultiLine = () => {
  const leftSlider = document.getElementById('left-slider')
  const leftSpanElement = leftSlider?.querySelector('span')
  const rightSlider = document.getElementById('right-slider')
  const rightSpanElement = rightSlider?.querySelector('span')
  if (
    (rightSpanElement && isTextMultiLine(rightSpanElement))
    || (leftSpanElement && isTextMultiLine(leftSpanElement))
  ) {
    txtOnMultiplesLines.value = true
  } else {
    txtOnMultiplesLines.value = false
  }
}

const isTextMultiLine = (element: HTMLElement): boolean => {
  const computedStyle = window.getComputedStyle(element)
  const fontSize = parseFloat(computedStyle.fontSize) //fonctionne parce que les fonts sont en px, pas sur que ca fonctionne si on passe en rem
  const height = element.offsetHeight
  const moreThanOneLine = 2*fontSize < height

  return moreThanOneLine
}
</script>
<style lang="scss" scoped>

//VARIABLES
$gap-md: 1.75rem;
$gap-xs: 0.250rem;
$breakpoint-xs: 375px;
$breakpoint-sm: 480px;
$breakpoint-md: 768px;
$breakpoint-lg: 768px;
$breakpoint-xl: 1440px;
$breakpoint-xxl: 3840px;
$slider-label-width: 95%;
// DF9C06
.orange-font-color{
  color: var(--tertiary-font-color, #FFA300);
}
//COMMON CLASSES
.slider-pill-borders {
  border: 1pt solid;
  // border-color: white;
  border-radius: 10rem;
  padding: 2pt;

  .slider-wrapper {
    height: 100%;
    border-radius: 10rem;
    display: grid;
    column-gap: 0;
    row-gap: $gap-xs;
    width: 100%;
    max-width: 100%;
    grid-template-areas:
      "left-slider"
      "slider"
      "right-slider";

    .slider {
      z-index: 2;
      grid-area: slider;
      min-height: 1.5rem;
      height: 100%;
      mix-blend-mode: color-burn;
    }

    .label-slider {
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 45%;
      align-items: center;
      cursor: pointer;
      justify-content: center;
      white-space: break-spaces;
      z-index: 2;

      span {
        width: 100%;
      }

      span:active,
      span:focus {
        cursor: pointer;
        box-shadow: none;
        outline: none;
        border-radius: 0;
        background-color: transparent;
      }
    }

    .left-slider {
      height: 100%;
      width: 100%;
      top: 0;
    }

    .right-slider {
      height: 100%;
      width: 100%;
      top: 0;
      right: 0;
    }
    .paragraph {
        text-align: center;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        line-height: 0.9rem;
    }
  }

  // ANIMATIONS
  .slider-wrapper>.label-slider>.fluid-transition {
    transition-duration: 250ms;
  }

  //MEDIA QUERIES
  @media (min-width: $breakpoint-xxl) {
    .slider-wrapper {
      grid-template-columns: 1fr 50% 1fr;
      grid-template-areas:
        "left-slider slider right-slider";
      column-gap: 0;
      row-gap: 0;
    }
  }

  @media (max-width: $breakpoint-xxl) {
    .slider-wrapper {
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "slider"
        "left-slider right-slider";

      .slider {
        grid-column-start: 1;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 4;
      }
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    .slider-wrapper>.label-slider {
      justify-content: unset;
    }
  }
}

</style>
